import request from '#/utils/request';
import { parseVer4DetailResponse } from '#/api/adapters/envelope';

/**
 * GET `/crm/sales-order/{id}/inventory-candidates`。
 * 允許狀態：DRAFT／PREPARING。可用量以本 API 為準（非 IMS InvStock 列表）。
 */
export async function fetchSalesOrderInventoryCandidates(id) {
  const { data: raw } = await request.get(
    `/crm/sales-order/${id}/inventory-candidates`,
  );
  return parseVer4DetailResponse(raw);
}
